<template>
  <div class="bg-light min-vh-100">
    <main class="container">
      <div class="row justify-content-center">
        <div class="col-lg-8">
          <div class="card shadow-sm">
            <div class="card-body">
              <h1 class="h4 mb-2">New Device</h1>
              <p class="help mb-3">
                Create a new refurbish device.
              </p>

              <form @submit.prevent="handleCreate">
                <!-- Device Model dropdown (required) -->
                <div class="mb-3">
                  <label class="form-label">Device Model</label>
                  <select v-model="selectedDeviceModel" class="form-select" required @change="onDeviceModelSelect">
                    <option disabled :value="null">Select a device model...</option>
                    <option v-for="dm in deviceModels" :key="dm.device_model_id" :value="dm.device_model_id">
                      {{ dm.make }} {{ dm.model_name }} {{ dm.common_name ? '(' + dm.common_name + ')' : '' }}
                    </option>
                  </select>
                </div>

                <!-- Serial Number -->
                <div class="mb-3">
                  <label class="form-label">Serial Number</label>
                  <input
                    v-model="form.serial_number"
                    type="text"
                    class="form-control"
                    required
                  />
                </div>

                <!-- Intake Condition (optional) -->
                <div class="mb-3">
                  <label class="form-label">Intake Condition <span class="text-muted fw-normal">(optional)</span></label>
                  <input
                    v-model="form.intake_condition"
                    type="text"
                    class="form-control"
                    placeholder="Visible damage, power state, notes"
                  />
                </div>

                <!-- Template (required) -->
                <div class="mb-3">
                  <label class="form-label">Template</label>
                  <select
                    v-model="form.template"
                    class="form-select"
                    required
                  >
                    <option disabled value="">Select template...</option>
                    <option
                      v-for="t in templates"
                      :key="t.template_id"
                      :value="t.template_id"
                    >
                      {{ t.template_name }} (v{{ t.template_version }})
                    </option>
                  </select>
                  <div class="form-text">
                    Only active templates are shown.
                  </div>
                </div>

                <!-- Error message -->
                <div v-if="error" class="alert alert-danger py-2">
                  {{ error }}
                </div>

                <!-- Buttons -->
                <div class="d-flex gap-2 mt-4">
                  <button
                    type="button"
                    class="btn btn-outline-secondary"
                    @click="$router.push({ name: 'OrdersList' })"
                  >
                    Cancel
                  </button>
                  <button
                    type="submit"
                    class="btn btn-primary"
                    :disabled="loading"
                  >
                    <span
                      v-if="loading"
                      class="spinner-border spinner-border-sm me-1"
                    ></span>
                    Create Device
                  </button>
                </div>
              </form>

            </div>
          </div>
        </div>
      </div>
    </main>
  </div>
</template>

<script>
import { APIService } from "../http/APIService";

export default {
  name: "CreateOrder",
  data() {
    return {
      form: {
        serial_number: "",
        device_make: "",
        device_model: "",
        device_commonname: "",
        device_type: "",
        intake_condition: "",
        template: "",
        customer: null,
        device_model_ref: null,
      },

      deviceModels: [],
      selectedDeviceModel: null,
      templates: [],

      loading: false,
      error: null,
      api: new APIService(),
    };
  },

  created() {
    this.fetchTemplates();
    this.fetchDeviceModels();
  },

  methods: {
    async fetchTemplates() {
      try {
        const accessToken = localStorage.getItem("accessToken");
        const res = await this.api.getTemplates(accessToken);
        this.templates = res.data.filter((t) => t.active_template);
        if (this.templates.length === 1) {
          this.form.template = this.templates[0].template_id;
        }
      } catch {
        // silent fail
      }
    },

    async fetchDeviceModels() {
      try {
        const accessToken = localStorage.getItem("accessToken");
        const res = await this.api.getDeviceModels(accessToken);
        this.deviceModels = res.data || [];
      } catch {
        // silent fail
      }
    },

    onDeviceModelSelect() {
      if (!this.selectedDeviceModel) {
        this.form.device_model_ref = null;
        this.form.device_make = "";
        this.form.device_model = "";
        this.form.device_commonname = "";
        this.form.device_type = "";
        return;
      }
      const dm = this.deviceModels.find((m) => m.device_model_id === this.selectedDeviceModel);
      if (dm) {
        this.form.device_make = dm.make;
        this.form.device_model = dm.model_name;
        this.form.device_commonname = dm.common_name || "";
        this.form.device_type = dm.device_type || "Laptop";
        this.form.device_model_ref = dm.device_model_id;
      }
    },

    async handleCreate() {
      this.error = null;
      this.loading = true;

      try {
        const accessToken = localStorage.getItem("accessToken");
        const res = await this.api.createOrder(this.form, accessToken);

        const newId = res.data?.order_id;
        if (!newId) {
          throw new Error("Order ID missing in createOrder response");
        }

        this.$router.push({ name: "OrderDetail", params: { id: newId } });
      } catch (err) {
        console.error("Create order failed:", err);
        this.error = "Unable to create device.";
      } finally {
        this.loading = false;
      }
    },
  },
};
</script>
